/**
 * United States dollar.
 */
export var USD = {
  code: 'USD',
  base: 10,
  exponent: 2
};